import getApolloClient from './dist/apollo-client/client';

export default getApolloClient;
